import { head } from 'ramda';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { TextButton } from '../../../components/common';
import { MainSource } from '../../../constants/Source';
import { RouteBuilder } from '../../../utils/RouteHelpers';
import { Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const addedItemsToBoardNotification =
  ({ boards, items }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        dataHook="items-added-to-board-notification"
        text={
          <FormattedMessage
            id="boards.modal.add-files.notification"
            values={{
              itemsCount: items.length,
              itemName: <Truncated>{head(items).name}</Truncated>,
              boardLink: (
                <FormattedMessage
                  id="boards.modal.add-files.notification.board.link"
                  values={{
                    boardsCount: boards.length,
                    link: (
                      <TextButton
                        as={Link}
                        size="small"
                        to={RouteBuilder.Source(MainSource.Boards, head(boards).id, head(items).id)}
                        underline="always"
                        skin="dark"
                        dataHook="notification-link"
                      >
                        {head(boards).name}
                      </TextButton>
                    ),
                  }}
                />
              ),
            }}
          />
        }
      />
    );
